// Every report-param key the info-view histogram chart can persist, each set to null.

import { buildClearParams } from '@aytm/app/stats/page/question-views/components/lib/clear-params'

const QUESTION_PARAMS = ['hg']

export const calcClearParams = ({ questionKey, answerVariants, batches, clusters } = {}) =>
  buildClearParams({ questionKey, answerVariants, batches, clusters, question: QUESTION_PARAMS })
